<template>
  <layout class="page-result">
    <div slot="banner"></div>
    <div class="empty-box"></div>

    <div class="finalist">
      <div class="layout-content">
        <div class="page-title">
          <div class="title-competition">
            <div>
              <p class="title-competition-ch">{{data.subTitleEn}}</p>
              <p class="title-competition-en" v-html="data.subTitle"></p>
            </div>

            <img class="title-competition-img" :src="isMobile ? data.mobileTitleImg : data.titleImg" alt="年份图片">
          </div>
          <div class="title-line"></div>
        </div>

        <div class="introduction">
          <div class="introduction-text">
            <p v-for="(p, index) in data.introduction.intro" :key="index" v-html="p"></p>
          </div>
          <div class="right">
            <i class="bofang" @click="playHandler(data.introduction.video)"></i>
            <div class="img-wrap">
              <div class="mask"></div>
              <img class="img-video" :src="data.introduction.poster" alt="">
            </div>
          </div>
        </div>

        <div
          v-for="(item) in data.finalist.content"
          :id="item.alias"
          :key="item.alias"
        >
          <div class="title-wrap">
            <SubTitle :text="item.title"  />
          </div>

          <div
            class="content-wrap"
          >
            <div
              class="content"
              v-for="each in item.list"
              :key="each.title"
            >
              <div class="image"><img :src="each.image"></div>

              <div class="intro">
                <div class="content-title">
                  {{ each.title }}
                  <div
                    class="span"
                    :data-type="each.alias"
                  >
                    {{ each.type_title }}
                  </div>
                </div>

                <div class="intro-content">
                  <div class="intro-content-title">参赛作品：</div>
                  <div class="intro-content-info intro-content-info-product">{{ each.product }}</div>
                </div>
                <div class="intro-content">
                  <div class="intro-content-title">参赛成员：</div>
                  <div class="intro-content-info intro-content-info-member">{{ each.member }}</div>
                </div>
                <div class="intro-content">
                  <div class="intro-content-title"><span class="space">学</span>校：</div>
                  <div class="intro-content-info intro-content-info-school">{{ each.school }}</div>
                </div>
                <div class="intro-content">
                  <div class="intro-content-title">作品简介：</div>
                  <div class="intro-content-info intro-content-info-intro">{{ each.pro_intro }}</div>
                </div>
              </div>

              <div class="bottom-line" :data-type="item.alias"></div>
            </div>
          </div>
        </div>

        <div class="section" id="videos">
          <div class="layout-content">
            <SubTitle :text="data.videos.titleCh" :subText="data.videos.titleEn" />
            <TrainingList :data="data.videos" />
          </div>
        </div>

      </div>
    </div>
  </layout>
</template>

<script>
import layout from '../../components/layout/layout'
import SubTitle from '../../components/SubTitle'

import TrainingList from '../../components/TrainingList'

import { mapState } from 'vuex'

import * as GlobalLayer from '@/utils/globalLayer'

export default {
  name: 'Result',

  components: {
    layout,
    SubTitle,
    TrainingList
  },

  data () {
    return {
    }
  },

  mounted () {
    if (!this.isMobile) {
      this.$nextTick(() => {
        const areaIds = ['first', 'second', 'third','fourth']
        const destiClass = ['product', 'member', 'school', 'intro']
        areaIds.forEach(aid => {
          destiClass.forEach(did => {
            this.setHeight(aid, `intro-content-info-${did}`)
          })
        })
      })
    }
  },

  computed: {
    ...mapState([
      'isMobile'
    ]),
    data () {
      return this.$t('past2025')
    }
  },

  methods: {
    setHeight (areaId, destiClass) {
      let height = 0
      const nodes = document.querySelector(`#${areaId}`).querySelectorAll(`.${destiClass}`)
      nodes.forEach(item => {
        height = Math.max(height, item.clientHeight)
      })
      nodes.forEach(item => {
        item.style.setProperty('height', `${height}px`)
      })
    },
    playHandler (video) {
      GlobalLayer.createModal(this.$store, {
        video
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.page-result {
  background: $bgGrey;
}

.empty-box {
  width: 100vw; height: 81px;

  @include mobile {
    height: 55px;
  }
}

.finalist {
  padding: 86px 0 141px;
  background: $bgGrey;

  @include mobile {
    padding: 24px 0 75px;
  }

  .layout-content {
    position: relative;
    z-index: 10;
  }
}


.title-competition {
  display: flex; justify-content: space-between; align-items: center;
}

.title-competition-ch {
  font-size: 36px; font-family: Alibaba-PuHuiTi-Heavy;
  color: #303030;
  line-height: 82px;
  letter-spacing: 2px;

  @include mobile {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 1px;
  }
}

.title-competition-en {
  font-size: 23px; font-family: Alibaba-PuHuiTi-Heavy;
  color: #303030;
  line-height: 31px;
  letter-spacing: 6px;

  @include mobile {
    margin: 10px 0;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    letter-spacing: 1px;
  }
}

.title-competition-img {
  width: 100px; height: 100px;
  border: 1px solid #000000;

  @include mobile {
    width: 50px; height: 50px;
    border: 1px solid #000000;
  }
}

.title-line {
  width: 100px; height: 8px;
  margin: 30px 0 60px;
  background: #DE3640;

  @include mobile {
    width: 34px; height: 3px;
    margin: 7px 0 16px;
  }
}

.introduction {
  padding-top: 20px;
  color: #000;

  @include mobile {
    padding-top: 16px;
  }
}

.introduction-text {
  flex: 1;

  & p {
    padding-bottom: 20px;
    line-height: 35px;
    @include font(16);

    &:last-child {
      padding-bottom: 0;
    }

    @include mobile {
      padding-bottom: 16px;
      line-height: 28px;
      font-size: 14px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }
}

.title-wrap {
  margin-top: 120px;

  & ::v-deep .title {
    font-family: 'fz';
  }

  @include mobile {
    margin-top: 50px;
  }
}

.content-wrap {
  display: flex; justify-content: center; align-items: stretch;
  gap: 24px;

  @include mobile {
    flex-direction: column;
    gap: 16px;
  }
}
.content {
  display: flex; flex-direction: column;
  width: 384px;

  @include mobile {
    width: 100%;
  }
}
.image {
  flex: none;
  width: 100%;

  img {
    width: 100%; height: 253px;
    object-fit: contain;
  }

  @include mobile {
    aspect-ratio: 335 / 221;

    img {
      height: 100%;
    }
  }
}
.intro {
  flex: 1;
  padding: 0 20px 24px;
  background-color: #fff;

  @include mobile {
    padding-bottom: 16px;
  }
}
.content-title {
  display: flex;
  margin-bottom: 19px;
  padding: 20px 0 19px;
  font-size: 18px; font-weight: 600;
  color: #000;
  line-height: 26px;
  border-bottom: 1px dashed rgba(#000000, 0.15);

  @include mobile {
    font-size: 16px;
    margin-bottom: 16px;
    padding: 16px 0 12px;
  }

  & .span {
    height: 20px;
    margin-top: 3px;
    margin-left: 8px;
    padding: 2px 5px;
    font-size: 12px;
    line-height: 18px;

    @include mobile {
      line-height: 18px;
    }
  }

  & [data-type="ai"] {
    background-color: #FEE7E5;
    color: #E1574D;
  }
  & [data-type="blockchain"] {
    background-color: #F2EDFF;
    color: #7652E1;
  }
  & [data-type="pm"] {
    background-color: #E7F2FF;
    color: #376EFD;
  }
  & [data-type="statistics"] {
    background-color: #e7fff9;
    color: #25a581;
  }
}
.intro-content {
  display: flex;
  margin-bottom: 14px;
  font-size: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  @include mobile {
    margin-bottom: 10px;
    font-size: 13px;
  }
}
.intro-content-title {
  flex: none;
  color: rgba(#000, 0.8);
  line-height: 24px;

  .space {
    margin-right: 30px;

    @include mobile {
      margin-right: 24px;
    }
  }

  // &.double-width-space {
  //   letter-spacing: 1em;
  // }
}
.intro-content-info {
  flex: 1;
  color: rgba(#000, 0.6);
  line-height: 24px;
  white-space: pre-line;
}
.bottom-line {
  height: 12px;

  &[data-type="first"] {
    background: linear-gradient(270deg, #FFF7E6 0%, #F7DDA1 100%);
  }
  &[data-type="second"] {
    background: linear-gradient(270deg, #F4F4F4 0%, #DDDDDD 100%);
  }
  &[data-type="third"] {
    background: linear-gradient(270deg, #FEF4EF 0%, #E1C6BA 100%);
  }
}

.right {
  position: relative;
  width: 804px; height: 362px;
  margin: 60px auto 0;

  @include mobile {
    width: 100%; height: 188px;
    margin: 20px auto 0;
  }

  i {
    $val: 50px;
    width: $val; height: $val;
    position: absolute; z-index: 10;
    @include absoluteCenter;
    display: block;
    background: url('~@/assets/transSave/resource/image/ef/69/efd0026a21de3da79eb68b8cb8a07969.png') center / cover no-repeat;
    cursor: pointer;
  }

  .img-wrap {
    $padding-top-bottom: 20px;
    $padding-left-right: 30px;
    width: 100%; height: 100%;
    padding: $padding-top-bottom $padding-left-right;
    position: relative;
    overflow: hidden;

    @include mobile {
      height: 188px;
    }

    img {
      width: 100%; height: 100%;
    }

    // .mask {
    //   position: absolute; top: $padding-top-bottom; right: $padding-left-right; bottom: $padding-top-bottom; left: $padding-left-right;
    //   background-color: rgba(#000, 0.3);
    // }

    .img-video {
      position: absolute; top: 0; right: 0; bottom: 0; left: 0;
      width: 804px; height: 452px;

      @include mobile {
        width: 100%; height: 188px;
      }
    }
  }
}

</style>
